import auth01 from './auth01.png'
import auth02 from './auth02.png'
import auth03 from './auth03.png'
import auth04 from './auth04.png'
export const stepInstructions = {
  Permissions: {
    instructions: {
      stepInstructions: [
        {
          title: 'Go to the API Key Management',
          description:
  <>
    Log in into
    Walmart Seller Central and navigate to <b>Settings {'>'} Consumer ID and Private Keys</b>, then click on <b>API Key Management</b> which would redirect you on API Keys page on the Developer Portal.
    You'll be taken to the <a href='https://developer.walmart.com/account'>Developer Portal</a> and automatically signed in.
    <br />
    API key is common for all software integrations but you also have option to <b>Add New Key For A Solution Provider</b> which allows to give specific API
    permissions for that software (use this option for SureDone API integration).
    <br />
    click on <b>Add New Key For A Solution Provider</b> and select <b>SureDone</b> from the drop-down list of all providers.
  </>,
          imgSrc: auth01,
          imgAlt: 'Go to the API Key Management'
        },
        {
          title: 'Click on SureDone Permissions',
          description:
  <>
    Once API keys for SureDone are added you have to give permissions to the API key. Click on <b>Permissions</b>

  </>,
          imgSrc: auth02,
          imgAlt: 'Click on SureDone Permissions'
        },
        {
          title: 'Give SureDone API Key Permissions',
          description:
  <>
    Now let's set permissions for the Integration.
    <br />
    <b>Item Management</b>
    <ul>
      <li><code>Content {'>'} Full Access </code></li>
      <li><code>Items {'>'} Full Access</code></li>
      <li><code>Inventory {'>'} Full Access</code></li>
      <li><code>Price {'>'} Full Access</code></li>
      <li><code>Lag Time {'>'} Full Access</code></li>
    </ul>
    <b>Order Management</b>
    <ul>
      <li><code>Orders {'>'} Full Access</code></li>
      <li><code>Returns {'>'} Full Access</code></li>
      <li><code>Shipping {'>'} Full Access</code></li>
    </ul>
    <b>Fullfilment</b>
    <ul>
      <li><code>Fullfilment {'>'} Full Access</code></li>
    </ul>
    <b>Shipping, Rules & Admin</b>
    <ul>
      <li><code>Rules {'>'} Full Access</code></li>
      <li><code>Reports {'>'} View Only</code></li>
      <li><code>Account Profile {'>'} No Access</code></li>
    </ul>
    <b>Analytics & Growth</b>
    <ul>
      <li><code>Growth {'>'} No Access</code></li>
    </ul>
  </>,
          imgSrc: auth03,
          imgAlt: 'Give SureDone API Key Permissions'
        },
        {
          title: 'Copy Client ID and Client Secret',
          description:
  <>
    Copy the <b>Client ID</b> and <b>Client Secret</b> and paste it in the fields below.
    <br />
    Then click on <b>Authorize Walmart</b> button.
  </>,
          imgSrc: auth04,
          imgAlt: 'Copy Client ID and Client Secret'
        }
      ]
    }
  }
}
